module.exports = __webpack_public_path__ + "img/selected6-min.bd39da0d.png";